import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseTableClass } from './base_table.class';
import { BaseTableVerticalClass } from './base_table_vertical.class';
import { StatusDocumentModel } from 'src/app/models/status/status-document.model';

@Component({
    selector: 'desktop-default-table',
    templateUrl: './desktop_table_default.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultTableComponent extends BaseTableClass {

  public openPreviewDocumentAllowed = (document: StatusDocumentModel) => this.openPreviewAllowed() && document.documentType !== 'JsonSignature' && this.isPossibleToViewRendering(document) 
}


@Component({
    selector: 'mobile-table-default',
    templateUrl: './mobile_table_default.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultMobileTableComponent extends BaseTableVerticalClass {
  @Input() tableName!: string;
  @Input() override tableData: any;

  public openPreviewDocumentAllowed = (document: StatusDocumentModel) => this.openPreviewAllowed() && document.documentType !== 'JsonSignature' && this.isPossibleToViewRendering(document) 
}

